/* eslint-disable */
import { addEvent, removeEvent } from '../utils/events';
import { addClasses, removeClasses } from '../utils/html';

export class Nav {

  /**
   * @param  {Dom}    nav             Navigation DOM element
   */
  constructor(nav) {

    this.nav = nav;

    if (!this.isEverythingOk()) {
      return;
    }

    this.isGlobal = nav.classList.contains('nav--global');
    this.isTouchSupported = ('ontouchstart' in window);
    this.isPointerSupported = ('pointerdown' in window);
    this.clickEvent = 'click';

    // this.navToggle = navToggle;
    this.navInner					= nav.querySelector('.nav__inner');
    this.navPrimary				= nav.querySelector('.nav__items--primary');
    this.navPrimaryItems	= this.navPrimary ? this.navPrimary.querySelectorAll('.nav__item--primary') : null;
    this.navActions				= nav.querySelector('.nav__actions');

    // Initialize navigation
    this.init();
  }

  init() {

    // Add the nav actions element if it doesn't already exist
    if (!this.navActions) {
      let navActions = document.createElement('ul');
      addClasses(navActions, ['nav__actions']);
      this.navInner.appendChild(navActions);
      this.navActions = navActions;
    }

    let mobileNavIconClass = this.isGlobal ? 'fa-bars' : 'fa-chevron-down';

    let newNavAction = document.createElement('li');

    this.navToggle = document.createElement('button');

    addClasses(newNavAction, ['nav__action', 'hide--md-and-up']);
    addClasses(this.navToggle, ['nav__action-btn', 'js-nav-toggle']);
    this.navToggle.innerHTML = '<i class="fa ' + mobileNavIconClass + '"></i>';
    newNavAction.appendChild(this.navToggle);
    this.navActions.appendChild(newNavAction);

    // Check if a primary navigation element exists
    if (this.navPrimaryItems) {

      // Bind the click event of the navigation toggle to the openMenu() method
      addEvent(this.navToggle, this.clickEvent, this.openMenu.bind(this));

      // Loop through each primary navigation item
      for (const navPrimaryItem of this.navPrimaryItems) {

        let navPrimaryItemLink  = navPrimaryItem.querySelector('a');
        let navSecondary        = navPrimaryItem.querySelector('.nav__items--secondary');

        // Check if this primary navigation item also contains secondary level navigation items
        if (navSecondary !== null) {

          let navSecondaryItems = navSecondary.querySelectorAll('.nav__item--secondary');

          // Determine the height of the sub nav and set the max-height as an inline style
          // as we need a fixed height for the CSS transition to work
          // let subNavHeight = subNav.offsetHeight;

          let navSecondaryHeight = (window.innerHeight / 100) * 75; // 75% of viewport width
          let navSecondaryMobileHeight = navSecondaryItems.length * 57; // TODO: Find a better way to determine the height of the sub nav

          navSecondary.setAttribute('data-height', navSecondaryHeight);
          navSecondary.setAttribute('data-mobile-height', navSecondaryMobileHeight);

          // Apply a "has-children" class to the primary navigation element if it doesn't already exist
          if (!navPrimaryItem.classList.contains('has-children')) {
            addClasses(navPrimaryItem, ['has-children']);
          }

          // Bind the click event of this primary navigation link to toggle the secondary navigation
          addEvent(navPrimaryItemLink, this.clickEvent, this.toggleSubMenu.bind(this, navPrimaryItem));

        } else {

          // This is a top-level link that has no sub-nav, so bind different events
          addEvent(navPrimaryItemLink, this.clickEvent, this.setPrimaryNavItemAsActive.bind(this, navPrimaryItem));

        }

      }

    }

  }

  /**
   * Removes the 'is-active' state from each navigation item at the specified level, i.e. primary or secondary.
   * @param level
   */
  deactivateNavItems(level) {
    let activeNavItems = this.nav.querySelectorAll('.nav__items--' + level + ' > .is-active');
    for (const activeNavItem of activeNavItems) {
      removeClasses(activeNavItem, ['is-active']);
    }
  }

  /**
   * Deactivates all currently active primary and secondary level navigation elements.
   * Marks the specified primary navigation item as active.
   * Closes the menu.
   * @param item
   */
  setPrimaryNavItemAsActive(item) {

    // Mark any currently active elements as inactive by removing the 'is-active' state
    this.deactivateNavItems('primary');
    this.deactivateNavItems('secondary');

    // Mark the current item as active
    if (!item.classList.contains('is-active')) {
      addClasses(item, ['is-active']);
    }

    // Finally, close the menu
    this.closeMenu();
  }

  /**
   * Utility method for determining if an element is visible in the DOM.
   * Taken directly from the jQuery source.
   * @param elem
   * @returns {boolean}
   * @see https://github.com/jquery/jquery/blob/master/src/css/hiddenVisibleSelectors.js
   */
  isVisible(elem) {
    return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
  }

  /**
   * Unbinds all click events at the primary and secondary level navigation elements.
   */
  destroy() {

    removeEvent(this.navToggle, this.clickEvent, this.openMenu);

    // Unbind the click events for all secondary navigation items
    let primaryNavItemsWithChildren = this.nav.querySelectorAll('.nav__items--primary.has-children');

    for (const primaryNavItem of primaryNavItemsWithChildren) {
      let primaryNavItemLink = primaryNavItem.querySelector('a');
      removeEvent(primaryNavItemLink, this.clickEvent, this.toggleSubMenu.bind(this, primaryNavItem));
    }

  }

  toggleSubMenu(primaryNavItem, e) {

    let isOpen = primaryNavItem.classList.contains('is-open');
    let secondaryNav = primaryNavItem.querySelector('.nav__items--secondary');
    let isMobileView = this.isVisible(this.navToggle);

    if (isOpen) {

      secondaryNav.style.maxHeight = '0px';
      removeClasses(primaryNavItem, ['is-open']);

    } else {

      let navSecondaryHeight = secondaryNav.getAttribute((isMobileView) ? 'data-mobile-height' : 'data-height');
      secondaryNav.style.maxHeight = navSecondaryHeight + 'px';

      addClasses(primaryNavItem, ['is-open']);

      // Bind click events to each link to close the nav if a link is clicked
      let secondaryNavLinks = secondaryNav.querySelectorAll('a');
      for (const secondaryNavLink of secondaryNavLinks) {
        addEvent(secondaryNavLink, this.clickEvent, this.secondaryNavItemLinkClicked.bind(this, primaryNavItem, secondaryNav), false);
      }

    }

  }

  secondaryNavItemLinkClicked(primaryNavItem, secondaryNav) {
    removeClasses(secondaryNav, ['is-open']);
    this.closeMenu();
  }

  openMenu() {

    if (!this.isGlobal) {
      let toggleIcon = this.navToggle.querySelector('i');
      if (toggleIcon.classList.contains('flip')) {
        removeClasses(toggleIcon, ['flip']);
      } else {
        addClasses(toggleIcon, ['flip']);
      }
    }

    if (this.nav.classList.contains('is-open')) {
      removeClasses(this.nav, ['is-open']);
      removeClasses(this.navPrimary, ['is-open']);
    } else {
      addClasses(this.nav, ['is-open']);
      addClasses(this.navPrimary, ['is-open']);
    }

    let isMobileView = this.isVisible(this.navToggle);

    if (isMobileView && this.isGlobal) {

      this.overlay = document.createElement('div');
      addClasses(this.overlay, ['overlay', 'fade', 'js-overlay']);
      this.navPrimary.parentNode.insertBefore(this.overlay, this.navPrimary);

      this.navSectionHeader = document.createElement('li');
      addClasses(this.navSectionHeader, ['nav__item--primary', 'nav__section--header', 'is-sticky']);
      this.navSectionHeader.innerText = 'Menu';

      this.navCloseBtn = document.createElement('button');
      addClasses(this.navCloseBtn, ['btn', 'btn--close', 'fade', 'js-close-menu']);
      this.navCloseBtn.innerHTML = '<i class="icon-cme-card-close"></i>';
      this.navSectionHeader.appendChild(this.navCloseBtn);

      this.navPrimary.insertBefore(this.navSectionHeader, this.navPrimary.firstChild);

      setTimeout(function() {
        addClasses(this.overlay, ['fade--in']);
        addClasses(this.navCloseBtn, ['fade--in']);
      }.bind(this), 100);

    }

    addEvent(this.navCloseBtn, this.clickEvent, this.closeMenu.bind(this));
  }

  closeMenu() {

    let isMobileView = this.isVisible(this.navToggle);

    removeClasses(this.nav, ['is-open']);
    removeClasses(this.navPrimary, ['is-open']);

    if (isMobileView) {

      if (this.isGlobal) {

        removeClasses(this.overlay, ['fade--in']);

        setTimeout(function() {
          // ChildNode.remove() is not supported in Internet Explorer,
          // so we have to resort to the longhand version of ParentNode.removeChild() instead
          this.overlay.parentNode.removeChild(this.overlay);
          this.navSectionHeader.parentNode.removeChild(this.navSectionHeader);
        }.bind(this), 300);

      } else {

        let toggleIcon = this.navToggle.querySelector('i');
        if (toggleIcon !== null && toggleIcon.classList.contains('flip')) {
          removeClasses(toggleIcon, ['flip']);
        }

      }

    }

  }

  /* eslint-disable no-console */
  isEverythingOk() {
    if (!this.nav) {
      console.warn('CommonUI - Nav - There\'s no nav found');
      return false;
    }
    return true;
  }
  /* eslint-enable no-console */

}

/**
 * Creates a new nav instance
 * @param  {Object} config
 */
export default function initNav(config = {}) {
  const { selector = '.js-nav' } = config;
  let navs = null;
  if (typeof selector === 'string') {
    for (const nav of document.querySelectorAll(selector)) {
      navs = new Nav(nav);
    }
  }
  return navs;
}



// WEBPACK FOOTER //
// ./js/components/Nav.js